import React from "react";
import NavegadorUtil from "../util/NavegadorUtil";
import logo from "../assets/images/oba-hortifruti.png";
import { Link, withRouter } from "react-router-dom";
import SearchDAO from "../dataAccess/Search/SearchDAO";

interface IBuscaProdutosProps {
  onChangeText?: any;
  parent: React.Component;
}

type BuscaProdutosState = {
  query: string;
  searchSuggestion: string[],
  searchProducts: any[],
};

class BuscaProdutos extends React.Component<
  IBuscaProdutosProps & any,
  BuscaProdutosState
> {
  constructor(props: IBuscaProdutosProps & any) {
    super(props);
    this.state = {
      query: "",
      searchSuggestion: [],
      searchProducts: [],
    };
  }

  changeText(t: string): void {

    if (this.props.onChangeText) {
      this.props.onChangeText(t);
    }

    if (t.length>0)
      SearchDAO.getInstance().suggestProducts(t).then((s: any) => {
        this.setState({
          query: t,
          searchSuggestion: s,
        });
      });
    // this.setState({
    //   query: t,
    //   searchSuggestion: [],
      // searchProducts: [
      //   {
      //     prodId: 6446,
      //     photo: 'https://oba-img.azureedge.net/product/15578-vinho-argentino-fuego-negro-cabernet-sauvignon-tinto-750-ml-m.jpg',
      //     name: '1 Vinho Chileno Perez Cruz Reserva Tinto 750ml',
      //     current: '69,99',
      //     unit: 'un',
      //   }, {
      //     prodId: 6446,
      //     photo: 'https://oba-img.azureedge.net/product/15578-vinho-argentino-fuego-negro-cabernet-sauvignon-tinto-750-ml-m.jpg',
      //     name: '2 Vinho Chileno Perez Cruz Reserva Tinto 750ml',
      //     current: '49,99',
      //     unit: 'un',
      //   }, {
      //     prodId: 6446,
      //     photo: 'https://oba-img.azureedge.net/product/15578-vinho-argentino-fuego-negro-cabernet-sauvignon-tinto-750-ml-m.jpg',
      //     name: '3 Vinho Chileno Perez Cruz Reserva Tinto 750ml',
      //     current: '39,99',
      //     unit: 'un',
      //   }, {
      //     prodId: 6446,
      //     photo: 'https://oba-img.azureedge.net/product/15578-vinho-argentino-fuego-negro-cabernet-sauvignon-tinto-750-ml-m.jpg',
      //     name: '4 Vinho Chileno Perez Cruz Reserva Tinto 750ml',
      //     current: '79,99',
      //     unit: 'un',
      //   }, {
      //     prodId: 6446,
      //     photo: 'https://oba-img.azureedge.net/product/15578-vinho-argentino-fuego-negro-cabernet-sauvignon-tinto-750-ml-m.jpg',
      //     name: '5 Vinho Chileno Perez Cruz Reserva Tinto 750ml',
      //     current: '89,99',
      //     unit: 'un',
      //   }]
    // });

    if (t === '') {
      this.setState({query:t, searchSuggestion: [], searchProducts: []});
    }
  }

  submitForm(e: any): any {
    if (this.state.query.trim().length < 3) {
      NavegadorUtil.alerta(
        this.props.parent,
        "Informe pelo menos três letras para buscar"
      );
      e.preventDefault();
    } else {
      e.preventDefault();
      const queryLink: string = `/busca?q=${encodeURIComponent(this.state.query)}`;
      this.props.history.push(queryLink);
    }
  }

  render(): any {

    const {
      query,
      searchSuggestion,
      searchProducts,
    } = this.state;

    return (
      <div className={`search ${query !== '' ? "active" : ""}`}>
        <form
          className="form" 
          action={NavegadorUtil.getUrl("/#/busca")}
          onSubmit={(e) => this.submitForm(e)}
        >
          <img src={logo} alt="Oba" className="logo" />
          <input
            type="text"
            name="q"
            id="search"
            placeholder="O que você procura"
            style={{ fontFamily: "Raleway, Arial, FontAwesome" }}
            onChange={(e) => this.changeText(e.target.value as string)}
          />
          <button>
            <i className="fas fa-arrow-circle-right"></i>
          </button>
        </form>
        <div className={`search-result ${ (query.length>0) ? "active" : ""}`}>
          { ( searchSuggestion.length === 0 && query.length > 0 ) &&
          <h2>Nenhum produto encontrado para a busca '{query}'</h2>
          }
          { searchSuggestion.length > 0 &&
          <>
            <div className={`col ${searchSuggestion.length>0 ? "active" : ""}`}>
              <h2>Sugestões</h2>
              <ul className="result-hint">
              { searchSuggestion.map((word: String) => (
                <li><Link to={NavegadorUtil.getUrl("/busca?q=")+word} onClick={() => this.changeText('')}>{word}</Link></li>
              ))}
              </ul>
            </div>
          </>
          }
          { searchProducts.length > 0 &&
          <div className={`col ${searchProducts.length>0 ? "active" : ""}`}>
            <h2>Produtos</h2>
            <ul className="result-product">
            { searchProducts.map((product: any) => (
              <li>
                <Link to={NavegadorUtil.getUrl("/produto?fm=200&prodId=")+product.prodId}>
                  <div className="photo">
                    <img src={product.photo} alt=""/>
                  </div>
                  <div className="details">
                    <p>{product.name}</p>
                    <p className="current"><span>R$ {product.current}</span> {product.unit}</p>
                  </div>
                </Link>
              </li>
            ))}
            </ul>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(BuscaProdutos);
